import { HeroShell } from "./hero-shell"
import type { HeroShellProps } from "./hero-types"

export type LeadFormHeroProps = HeroShellProps

export function LeadFormHero(props: LeadFormHeroProps) {
	return <HeroShell {...props} layout="inline-form" form={props.form ?? { fields: [{ name: "email", label: "Work email", type: "email", placeholder: "you@company.com", required: true }], submitLabel: "Get started", successMessage: "You are on the list." }} />
}